module.exports = __webpack_public_path__ + "img/sample-image.65bdad23.jpg";